import { SubGrid } from "@bryntum/schedulerpro";

// Workaround to fix incorrect cached width:
// https://github.com/bryntum/support/issues/5545
// TODO: Remove when corresponding issue is fixed
const widthPropertyDescriptor = Object.getOwnPropertyDescriptor(SubGrid.prototype, 'width');

if (widthPropertyDescriptor) {
  Object.defineProperty(SubGrid.prototype, 'width', {
    get() {
      // We will raise flag to ignore cache in certain moment allowing to use default implementation
      if (this._swivu_skipWidthCache) {
        return this.element.clientWidth;
      }
      else {
        return widthPropertyDescriptor.get.apply(this);
      }
    },
    set: widthPropertyDescriptor.set
  });
}
else {
  console.warn("Cannot patch width accessor on a SubGrid");
}
